import { render, staticRenderFns } from "./TransferOwnership.vue?vue&type=template&id=78b6a620&scoped=true&"
import script from "./TransferOwnership.vue?vue&type=script&lang=js&"
export * from "./TransferOwnership.vue?vue&type=script&lang=js&"
import style0 from "./TransferOwnership.vue?vue&type=style&index=0&id=78b6a620&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b6a620",
  null
  
)

export default component.exports